import { NavLink, Link, useLocation } from "react-router-dom";
import { changeSiteLang, logUserOut, selectUser } from "../../../store/userSlice";
import style from "./index.module.css";
import { Close, Logout, Profile } from "../../../components/Icons";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "../../../hooks/useTranslation";
import { VehicleModule, vehicleModules } from "../../../utils/GeneralTypes";
import { useCallback, useEffect } from "react";
import Accordion from "../../../components/UI/Accordion/Accordion";
import { useTypedSelector } from "../../../store/store";
import {
  selectTypeCategories,
  selectTypeCategoriesError,
  selectTypeCategoriesLoading,
} from "../../../store/vehicleTypeCategoriesSlice";
import { navLinkIsActive } from "./shared";
import { Plus, Earth, LogIn, Newspaper, Store, Wrench, LayoutList, UserRoundPen, Star, Mail } from "lucide-react";

function MobileMenuItem(vehicleModule: VehicleModule) {
  const loc = useLocation();
  const { locale } = useTranslation();
  const categories = useTypedSelector((state) => selectTypeCategories(state, vehicleModule.single));
  const isLoading = useTypedSelector((state) => selectTypeCategoriesLoading(state, vehicleModule.single));
  const error = useTypedSelector((state) => selectTypeCategoriesError(state, vehicleModule.single));

  const onExpandMobileNav = useCallback(() => {
    if (window.innerWidth <= 992) {
      const overlay = document.querySelector(`.${style.header__overlay}`);
      const nav = document.querySelector(`.${style.header__nav}`);
      if (nav?.classList?.contains(style[`header__nav--expanded`])) {
        nav.classList.remove(style[`header__nav--expanded`]);
        overlay?.classList?.remove(style[`header__overlay--visible`]);
      } else {
        nav?.classList?.add(style[`header__nav--expanded`]);
        overlay?.classList?.add(style[`header__overlay--visible`]);
      }
    }
  }, []);

  // TODO: add better loading state
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!categories) return null;

  return (
    <Accordion
      // note: using this nasty key to trigger rerender after url change(user selection)
      key={`${vehicleModule.plural}mobile${loc.search}`}
      icon={<vehicleModule.Icon width="35" height="35" color="#000000" />}
      title={locale(vehicleModule.plural)}
    >
      <ul>
        {categories.map((category, index) => (
          <li key={`${index}mobilecategory`} onClick={onExpandMobileNav}>
            <NavLink
              to={`/used-${vehicleModule.plural}/find?category0=${category.id}`}
              className={(isActive) => {
                return isActive ? style.active : "";
              }}
              isActive={navLinkIsActive(category.id.toString())}
            >
              <img style={{ maxWidth: "30px", maxHeight: "30px" }} src={category.icon} />
              &nbsp;&nbsp;{category.name}
            </NavLink>
          </li>
        ))}
      </ul>
    </Accordion>
  );
}

const MobileNav = () => {
  const dispatch = useDispatch();
  const { locale } = useTranslation();
  const { user, siteLang } = useSelector(selectUser);

  const onExpandMobileNav = useCallback(() => {
    if (window.innerWidth <= 992) {
      const overlay = document.querySelector(`.${style.header__overlay}`);
      const nav = document.querySelector(`.${style.header__nav}`);
      if (nav?.classList?.contains(style[`header__nav--expanded`])) {
        nav.classList.remove(style[`header__nav--expanded`]);
        overlay?.classList?.remove(style[`header__overlay--visible`]);
      } else {
        nav?.classList?.add(style[`header__nav--expanded`]);
        overlay?.classList?.add(style[`header__overlay--visible`]);
      }
    }
  }, []);
  return (
    <>
      <button
        className={style.sellVehicleButtonMobile}
        onClick={() => {
          onExpandMobileNav();
          window.location.href = "/sell-vehicle/bus";
        }}
      >
        <Plus width="17" height="17" color="#fff" /> {locale("sell_vehicle")}
      </button>

      <li className={style.mobile_nav_link}></li>

      <button onClick={onExpandMobileNav} className={style.header__nav_close}>
        <Close height="17" width="17" color="#2f2f2f" />
      </button>

      <li className={style.mobile_nav_link}>
        {vehicleModules.map((module, index) => (
          <div key={`module${index}`}>
            <MobileMenuItem {...module} />
          </div>
        ))}
      </li>
      {/*
      <li className={style.mobile_nav_link}>
        <Accordion title={locale("distributor")} icon={<Landmark width="17" height="17" />}>
          <ul>
            {vehicleModules.map((vehicelName) => (
              <li key={`ddistributor${vehicelName.single}`} onClick={onExpandMobileNav}>
                <NavLink
                  className={(isActive) => {
                    return isActive ? style.active : "";
                  }}
                  to={`/distributor/${vehicelName.plural}`}
                >
                  {locale(vehicelName.plural)}
                </NavLink>
              </li>
            ))}
          </ul>
        </Accordion>
      </li>
      */}
      {/* <li className={style.mobile_nav_link}>
        <NavLink
          className={(isActive) => {
            return isActive ? style.active : "";
          }}
          to="/vehicles/search"
        >
          {locale("vehiclesSearch")}
        </NavLink>
      </li> */}
      <li className={style.mobile_nav_link} onClick={onExpandMobileNav}>
        <NavLink
          className={(isActive) => {
            return isActive ? style.active : "";
          }}
          to="/showrooms"
        >
          <Store width="17" height="17" />
          &nbsp;&nbsp;{locale("showrooms")}
        </NavLink>
      </li>
      <li className={style.mobile_nav_link} onClick={onExpandMobileNav}>
        <NavLink
          className={(isActive) => {
            return isActive ? style.active : "";
          }}
          to="/service-centers"
        >
          <Wrench width="17" height="17" />
          &nbsp;&nbsp;{locale("service_centers")}
        </NavLink>
      </li>
      {/*<li className={style.mobile_nav_link} onClick={onExpandMobileNav}>
        <NavLink
          className={(isActive) => {
            return isActive ? style.active : "";
          }}
          to="/sell-vehicle/truck"
        >
          {locale("sell_vehicle")}
        </NavLink>
      </li>*/}

      <li className={style.mobile_nav_link} onClick={onExpandMobileNav}>
        <NavLink
          className={(isActive) => {
            return isActive ? style.active : "";
          }}
          to="/news"
        >
          <Newspaper width="17" height="17" />
          &nbsp;&nbsp;{locale("news")}
        </NavLink>
      </li>

      {user ? (
        <li className={style.mobile_nav_link}>
          <Accordion title={locale("profile")} icon={<Profile width="17" height="17" color="#dc0000" />}>
            <ul>
              <li onClick={onExpandMobileNav}>
                <NavLink
                  className={(isActive) => {
                    return isActive ? style.active : "";
                  }}
                  to="/profile"
                >
                  <UserRoundPen width="17" height="17" color="#dc0000" />
                  &nbsp;{locale("edit_profile")}
                </NavLink>
              </li>
              <li onClick={onExpandMobileNav}>
                <Star width="17" height="17" color="#dc0000" />
                &nbsp;
                <Link to="/wishlist/cars/used">{locale("wishlist")}</Link>
              </li>
              <li onClick={onExpandMobileNav}>
                <LayoutList width="17" height="17" color="#dc0000" />
                &nbsp;
                <Link to={`/my-vehicles/${vehicleModules[0].plural}`}>{locale("my_vehicles")}</Link>
              </li>
              <li onClick={onExpandMobileNav}>
                <button onClick={() => dispatch(logUserOut())}>
                  <Logout width="17" height="17" color="#dc0000" />
                  &nbsp;
                  {locale("logout")}
                </button>
              </li>
            </ul>
          </Accordion>
        </li>
      ) : (
        <li className={style.mobile_nav_link} onClick={onExpandMobileNav}>
          <NavLink
            className={(isActive) => {
              return isActive ? style.active : "";
            }}
            to="/sign"
          >
            <LogIn width="17" height="17" color="#dc0000" />
            &nbsp;&nbsp;{locale("login")}
          </NavLink>
        </li>
      )}
      <li className={style.mobile_nav_link} onClick={onExpandMobileNav}>
        <NavLink
          className={(isActive) => {
            return isActive ? style.active : "";
          }}
          to="/contact"
        >
          <Mail width="17" height="17" color="#dc0000" />
          &nbsp;&nbsp;{locale("contact_us")}
        </NavLink>
      </li>

      <li className={style.mobile_nav_link}>
        <button
          onClick={() => {
            changeSiteLang(siteLang === "en" ? "ar" : "en");
            onExpandMobileNav();
          }}
        >
          <Earth width="17" height="17" color="#dc0000" />
          &nbsp;&nbsp;{siteLang === "ar" ? "English" : "عربى"}
        </button>
      </li>
    </>
  );
};

export default MobileNav;
